// extracted by mini-css-extract-plugin
export var columnList = "_cs-0";